import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import api from '@survey/api'

@Component({

})
export default class SurveyStatisticsExamples extends Vue {
    @Prop({ type: Object }) value!: { 
        question: survey.SurveyStatisticsItem
        data: Array<survey.ExampleStatistics> 
    }
    @Prop({ type: Number }) totalCount!: number
    @Prop({ type: Boolean }) isAnonymous!: boolean

    isInitAdditionalAnswer: boolean = false
    additionalAnswers: Array<survey.SurveyStatisticsItem> = []

    //카운트가 제일 높은 경우 font blue
    highestCount: number = 0
    additionalTotalCount : number = 0

    isHighest(exampleId: number | null) {
        let highestId: number | null = this.value.data.reduce((p, c) => {
            if(p.answerCount < c.answerCount) return c
            else return p
        }, this.value.data[0]).surveyExampleId;

        return highestId === exampleId;
    }  

    //미사용
    poopupDetail(questionId: number) {
        // (window as any).alertAsync(`상셍보기 팝업 발생 아이디 : ${questionId}`)
        api.survey.getSurveyStatisticsDetailLists(questionId)
            .then(result => {
                this.$emit('modal', result)
            })
    }

    CalculatePercent(answerCount: number) {
        if(this.totalCount == 0) {
            return `0%`
        } else {
            return `${(answerCount / this.totalCount * 100).toFixed(1)}%`
        }        
    }   

    exceptAdditionalAnswer() {        
        return this.value.data.filter(item => {
            return item.isAdditionalAnswer == false
        })
    }    
}
